import { HintHookOptions, HintVirtualElement, useHint } from '../Hint/index.js';

export interface HotkeyHintHookOptions extends HintHookOptions {}

/**
 * Hook to use the hotkey hint for handling as popper element
 */
export const useHotkeyHint = <TElement extends HintVirtualElement = HintVirtualElement>(
  opts?: HotkeyHintHookOptions
) => {
  return useHint<TElement>({
    ...opts,
    offset: [0, -8],
  });
};
